import React from 'react';
import Button from 'react-bootstrap/Button';
import { bcLogoPrint } from '../../../assets/images';
import { formatter } from '../../../utility';
import { RentIncreaseBreakdown } from '../StepThree/RentIncreaseBreakdown';

const GeneratedNoticePhase1 = (props) => {
  const { formData } = props;

  const renderSectionOne = () => {
    const address = formData.address;
    const userAccessDate = formData.userAccessDate;
    const selectedRentIncreaseAmount = formData.selectedRentIncreaseAmount;
    const rentIncreaseDate = formData.selectedRentIncreaseDate;
    const calcMissedRentIncreaseDate = formData.calcMissedRentIncreaseDate;
    const minRentIncreaseDate = formData.minRentIncreaseDate;
    const maxRentIncreaseDate = formData.maxRentIncreaseDate;
    const rentAmountAdditionalPortion = formData.rentAmountAdditionalPortion;
    const inPersonMinServiceDate = formData.inPersonMinServiceDate;
    const emailDoorFaxMinServiceDate = formData.emailDoorFaxMinServiceDate;
    const regMailMinServiceDate = formData.regMailMinServiceDate;
    const calcRentIncreaseCausedLoss = formData.calcRentIncreaseCausedLoss;
    const calcRentIncreaseServiceTimeIsAvailable = formData.calcRentIncreaseServiceTimeIsAvailable;
    const selectedRentIncreaseDate = formData.selectedRentIncreaseDate;
    const phaseOneRemainingEligibleAmount = formData.phaseOneRemainingEligibleAmount;

    const renderRentAmount = () => {
      if (!calcRentIncreaseCausedLoss && calcRentIncreaseServiceTimeIsAvailable && selectedRentIncreaseAmount) {
        return <span className="generated-notice__label"><span className="generated-notice__rent-amount">New rent amount:</span>&nbsp;<span className="generated-notice__label__value"><b>{formatter.toAmountDisplay(selectedRentIncreaseAmount)}</b></span></span>;
      }
    }

    const renderRentIncreaseDate = () => {
      if (!calcRentIncreaseCausedLoss && calcRentIncreaseServiceTimeIsAvailable && selectedRentIncreaseDate) {
        return <span className="generated-notice__label"><span className="generated-notice__increase-date">Effective date of rent increase:</span>&nbsp;<span className="generated-notice__label__value"><b>{formatter.toDateDisplay(rentIncreaseDate)}*</b></span></span>;
      }
    }

    const renderMissedRentIncreaseDate = () => {
      if ((calcRentIncreaseCausedLoss || !calcRentIncreaseServiceTimeIsAvailable) && calcMissedRentIncreaseDate ) {
        return <span className="generated-notice__label"><span className="generated-notice__lost-increase-date">Date of lost Phase 1 additional rent increase amount:</span>&nbsp;<span className="generated-notice__label__value"><b>{formatter.toDateDisplay(calcMissedRentIncreaseDate)}</b></span></span>;
      }
    }

    const renderLostFirstYearRentIncreaseWarning = () => {
      if(calcRentIncreaseCausedLoss || !calcRentIncreaseServiceTimeIsAvailable) {
        return (
          <div className="alert-error generated-notice__section-one__alert">
            <b>Lost Phase 1 additional rent increase: </b> The Phase 1 additional rent increase was not imposed between the required dates of {formatter.toDateDisplay(minRentIncreaseDate)} and {formatter.toDateDisplay(maxRentIncreaseDate)}. 
            For this reason, the eligible amount for the Phase 1 additional rent increase has become an unused portion in the amount of <b>{formatter.toAmountDisplay(rentAmountAdditionalPortion)}</b>. This 
            unused portion cannot be carried forward to the next phase or any future rent increase. The landlord has a remaining eligible amount of <b>{formatter.toAmountDisplay(phaseOneRemainingEligibleAmount)}</b> for future additional rent increases.
          </div>
        );
      }
    }

    const renderServiceDate = () => {
      if (!calcRentIncreaseCausedLoss && calcRentIncreaseServiceTimeIsAvailable) {
        return (
          <div className="generated-notice__section-one__service-date">
            <span>Last date on which notice must be served to the tenant(s)</span>
            <ul>
              <li>{formatter.toDateDisplay(inPersonMinServiceDate)} if the notice of rent increase is served in person</li>
              <li>{formatter.toDateDisplay(emailDoorFaxMinServiceDate)} if the notice of rent increase is served by pre-agreed email, posted on door, or fax</li>
              <li>{formatter.toDateDisplay(regMailMinServiceDate)} if the notice of rent increase is served by registered mail</li>
            </ul>
          </div>
        );
      }
    }

    return (
      <>
        <div className="generated-notice__section-one">
          <span className="generated-notice__section-one__title">Section 1: RENT INCREASE AMOUNT, DATES AND SERVICE</span>
          <span className="generated-notice__label"><span className="generated-notice__rental-unit">Rental unit address:</span>&nbsp;<span className="generated-notice__label__value"><b>{address}*</b></span></span>
          <span className="generated-notice__label"><span className="generated-notice__date-generated">Date rent increase insert generated:</span>&nbsp;<span className="generated-notice__label__value">{formatter.toDateDisplay(userAccessDate)}</span></span>
          { renderRentAmount() }
          { renderRentIncreaseDate() }
          { renderMissedRentIncreaseDate() }

          { renderLostFirstYearRentIncreaseWarning() }
          { renderServiceDate() }
        </div>
      </>
    );
  }

  const renderSectionTwo = () => {
    const decisionDate = formData.decisionDate;
    const decisionEligibleAmount = formData.decisionEligibleAmount;
    const rentAmountUsedForCalc = formData.rentAmountUsedForCalc;
    const previousYearRentIncreaseDate = formData.previousYearRentIncreaseDate;
    const minRentIncreaseDate = formData.minRentIncreaseDate;
    const maxRentIncreaseDate = formData.maxRentIncreaseDate;
    const rentCPIAmountStandardRentIncrease = formData.rentCPIAmountStandardRentIncrease;
    const rentAmountStandardRentIncrease = formData.rentAmountStandardRentIncrease;
    const rentAmountAdditionalPortion = formData.rentAmountAdditionalPortion;
    const rentAmountFinalAdditionalRentIncrease = formData.rentAmountFinalAdditionalRentIncrease;
    const cpiValue = formData.calcCPIValue ? formData.calcCPIValue.value : 0;
    const cpiYear = formData.calcCPIYear;
    const phaseOneRemainingEligibleAmount = formData.phaseOneRemainingEligibleAmount;
    const calcRentIncreaseCausedLoss = formData.calcRentIncreaseCausedLoss;
    const calcRentIncreaseServiceTimeIsAvailable = formData.calcRentIncreaseServiceTimeIsAvailable;
    const rentMaxAmountAdditionalPortion = formData.rentMaxAmountAdditionalPortion;
    const calcMissedRentIncreaseDate = formData.calcMissedRentIncreaseDate;

    const renderPreviousRentIncrease = () => {
      return <span className="generated-notice__label"><span className="generated-notice__previous-increase-date">Date of previous rent increase for this unit:</span> &nbsp;<span className="generated-notice__label__value">{previousYearRentIncreaseDate ? formatter.toDateDisplay(previousYearRentIncreaseDate) : 'Not applicable'}</span></span>;
    }

    const renderEligibleAmount = () => {
      if (!calcRentIncreaseCausedLoss && calcRentIncreaseServiceTimeIsAvailable) {
        return <span className="generated-notice__label">Eligible amount used by Phase 1 additional rent increase: &nbsp;<span className="generated-notice__label__value">{formatter.toAmountDisplay(rentAmountAdditionalPortion)}</span></span>;
      }
    }

    return (
      <div className="generated-notice__section-two">
        <span className="generated-notice__section-two__title">Section 2: SUPPORTING INFORMATION</span>
        <span className="generated-notice__label"><span className="generated-notice__rtb-date">Date of Residential Tenancy Branch decision:</span>&nbsp;<span className="generated-notice__label__value"><b>{formatter.toDateDisplay(decisionDate)}*</b></span></span>
        <span className="generated-notice__label"><span className="generated-notice__eligible-amount">Eligible amount for this unit in the decision:</span>&nbsp;<span className="generated-notice__label__value"><b>{formatter.toAmountDisplay(decisionEligibleAmount)}*</b></span></span>
        <span className="generated-notice__label"><span className="generated-notice__prior-increase">Rent amount for this unit prior to this rent increase:</span>&nbsp;<span className="generated-notice__label__value"><b>{formatter.toAmountDisplay(rentAmountUsedForCalc) || '-'}*</b></span></span>
        { renderPreviousRentIncrease() }
        <span className="generated-notice__label"><span className="generated-notice__phase">Phase of this additional rent increase:</span>&nbsp;<span className="generated-notice__label__value">Phase of this additional rent increase: First of up to three (3) maximum additional rent increases</span></span>
        <span className="generated-notice__label"><span className="generated-notice__earliest-increase-date">Earliest date allowed for Phase 1 additional rent increase:</span>&nbsp;<span className="generated-notice__label__value">{formatter.toDateDisplay(minRentIncreaseDate)}</span></span>
        <span className="generated-notice__label"><span className="generated-notice__latest-increase-date">Final month for Phase 1 additional rent increase to be imposed:</span>&nbsp;<span className="generated-notice__label__value">{formatter.toDateDisplay(maxRentIncreaseDate)}</span></span>
      
        <div className="generated-notice__section-two__calculation">
          <span className="generated-notice__label">Rent Increase Calculation:</span>
          
          <RentIncreaseBreakdown 
            decisionEligibleAmount={decisionEligibleAmount} 
            rentAmountUsedForCalc={rentAmountUsedForCalc} 
            rentCPIAmountStandardRentIncrease={rentCPIAmountStandardRentIncrease}
            rentAmountStandardRentIncrease={rentAmountStandardRentIncrease}
            rentAmountAdditionalPortion={rentAmountAdditionalPortion}
            rentAmountFinalAdditionalRentIncrease={rentAmountFinalAdditionalRentIncrease}
            rentMaxAmountAdditionalPortion={rentMaxAmountAdditionalPortion}
            calcRentIncreaseCausedLoss={calcRentIncreaseCausedLoss}
            calcRentIncreaseServiceTimeIsAvailable={calcRentIncreaseServiceTimeIsAvailable}
            calcMissedRentIncreaseDate={calcMissedRentIncreaseDate}
            cpiValue={cpiValue}
            cpiYear={cpiYear}
          />

          { renderEligibleAmount() }
          <span className="generated-notice__label">Remaining eligible amount for a Phase 2 additional rent increase on this unit: &nbsp;<span className="generated-notice__label__value">{formatter.toAmountDisplay(phaseOneRemainingEligibleAmount)}</span></span>
        </div>
      </div>
    )
  }

  return (
    <div className="generated-notice">
      <div className="hide-print">
        <p className="generated-notice__header">Phase 1 Additional Rent Increase Calculation</p>
        <span>
          Print or save as PDF to create a copy of the rent increase details below and attach it to a completed <a href="https://www2.gov.bc.ca/assets/gov/housing-and-tenancy/residential-tenancies/forms/rtb53-p1.pdf" target="_blank" rel="noopener noreferrer">#RTB-53-P1 form</a> with the additional rent increase decision. 
          You can then use these documents to provide notice to the tenant(s) of the rent increase. The amount of the rent increase and the dates on which the notice of additional rent increase must be served below are based on the information that you entered in the previous step. 
          If any of this information is incorrect, you can go back to the previous step and edit the information to correct it. <a href="https://www2.gov.bc.ca/gov/content/housing-tenancy/residential-tenancies/rent-rtb/rent-increase-costs-expenses" target="_blank" rel="noopener noreferrer">You can learn more on our website</a>.
        </span>
      </div>

      <div className="generated-notice__container">
        <div className="generated-notice__container__title hide-print">
          <Button variant="primary" className="generated-notice__container__title__edit" onClick={() => props.editInformation()}>Edit Information</Button>
          <Button variant="primary" className="generated-notice__container__title__print" onClick={() => window.print()}>Print</Button>
        </div>
        <div className="generated-notice__container__content">
          <div className="generated-notice__container__content__header">
            <img className="generated-notice__container__content__header__img" src={bcLogoPrint} alt='' />
            <div className="generated-notice__container__content__header__text">
              <span><b>#RTB-53P1D Additional Rent Increase</b></span>
              <span><b>First Phase Rent Increase Detail</b></span>
            </div>
          </div>
          <span className="generated-notice__container__content__instructions"><b>Instructions</b></span>
          <ul>
            <li>This form must be served to the tenant(s) with a completed #RTB-53-P1 form on or before the latest service dates below</li>
            <li>
              If any of the <b>bolded labels with a *</b> beside them are not accurate, this rent increase may not be valid and the tenant should <a href="https://www2.gov.bc.ca/gov/content/housing-tenancy/residential-tenancies/rent-rtb/rent-increase-costs-expenses" target="_blank" rel="noopener noreferrer">file an application
              with the residential tenancy branch</a> to dispute the rent increase
            </li>
          </ul>

          { renderSectionOne() }
          { renderSectionTwo() }

        </div>
      </div>
    </div>
  )
};

export default GeneratedNoticePhase1;